/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onbilgi_S2_Li3Inputs */

const tr_onbilgi_s2_li3 = /** @type {(inputs: Onbilgi_S2_Li3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Müşteri mesajlaşma modülü`)
};

const en_onbilgi_s2_li3 = /** @type {(inputs: Onbilgi_S2_Li3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Customer messaging module`)
};

const de_onbilgi_s2_li3 = /** @type {(inputs: Onbilgi_S2_Li3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modul für Kundennachrichten`)
};

const ru_onbilgi_s2_li3 = /** @type {(inputs: Onbilgi_S2_Li3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Модуль обмена сообщениями с клиентами`)
};

/**
* | output |
* | --- |
* | "Customer messaging module" |
*
* @param {Onbilgi_S2_Li3Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const onbilgi_s2_li3 = /** @type {((inputs?: Onbilgi_S2_Li3Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onbilgi_S2_Li3Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onbilgi_s2_li3(inputs)
	if (locale === "de") return de_onbilgi_s2_li3(inputs)
	if (locale === "ru") return ru_onbilgi_s2_li3(inputs)
	return tr_onbilgi_s2_li3(inputs)
});